module.exports = __webpack_public_path__ + "static/media/tti_save_time.f6be6337.png";